export const getVehicleInterests = (questions) => {
  let vehicleInterests = questions.filter((questionsection) => {
    return questionsection.question[0].name === 'VehicleInterestTypes';
  });
  vehicleInterests = vehicleInterests[0].question[0].constraints.split(',');
  return vehicleInterests.map((interest) => interest.trim());
};
